<template lang="pug">
  div#member-list
    template(v-if="!initialLoadComplete")
      VclTable(:rows="7" :columns="3")
    WtEntityTable(
      v-else
      :title="title"
      :data="_.get(memberResponseObject, 'data', [])"
      :pagination-object="memberResponseObject.pagination"
      :fetch-action="fetchAction"
      default-sort-field="username"
      :empty-message="emptyMessageText"
      enable-search
      @search="onSearch"
      :searchPlaceholder="searchPlaceholder"
    )
      BTableColumn(
        :cell-class="'has-text-hover'"
        field="username"
        label="Username"
        sortable
        :width="superAdminMemberList ? '16.666%' : '33.333%'"
        v-slot="column"
      )
        WtRouterLink(
          to="ProfilePage"
          :params="{ username: column.row.username }"
          type="table"
        )
          WtTableCellLongText(:text="column.row.username")
      BTableColumn(
        field="email"
        label="Email"
        sortable
        :width="superAdminMemberList ? '33.333%' : '41.666%'",
        v-slot="column"
      )
        WtTableCellLongText(:text="column.row.email")
      BTableColumn(
        v-if="showProgramColumn"
        field="programName"
        label="Program"
        sortable
        width="25%"
        v-slot="column"
      )
        WtTableCellLongText(:text="programName(column.row)")
      BTableColumn(
        field="walk_organizations_admins.admin_id"
        label="Admin"
        sortable
        centered
        :width="superAdminMemberList ? '8.333%' : '8.333%'"
        v-slot="column"
      )
        span(:class="isAdminClass(column.row)") {{ isAdminText(column.row) }}
      BTableColumn(
        label="Edit"
        centered
        :width="superAdminMemberList ? '8.333%' : '16.666%'"
        v-slot="column"
      )
        WtButton(isText bold @click.native="navigateToEditMember(column.row.id)") EDIT
      BTableColumn(v-if="superAdminMemberList" label="Login" centered width="8.333%" v-slot="column")
        a.login-icon(
          href="#"
          @click.prevent="handleLoginAsFromList(column.row.id)"
        )
          b-icon(icon="login")
</template>

<script>
import tablePropsMixin from "@/mixins/tablePropsMixin";
import VclTable from "@@/VclTable/VclTable";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";
import WtButton from "@@/WtButton/WtButton";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";
import WtTableCellLongText from "@@/WtTableCellLongText/WtTableCellLongText";
import { mapActions } from "vuex";

export default {
  name: "MemberList",

  components: {
    WtEntityTable,
    WtButton,
    VclTable,
    WtRouterLink,
    WtTableCellLongText
  },

  mixins: [tablePropsMixin],

  props: {
    memberResponseObject: {
      type: Object,
      required: true
    },

    initialLoadComplete: {
      type: Boolean,
      default: false
    },

    fetchAction: {
      type: Function,
      required: true
    },

    title: {
      type: String,
      default: "Member List"
    },

    searchPlaceholder: {
      type: String,
      default: "Search by username, name, or email address..."
    },

    showProgramColumn: {
      type: Boolean,
      default: false
    },

    superAdminMemberList: {
      type: Boolean,
      default: false
    },

    editMemberRouteName: {
      type: String,
      default: "MemberCenterSettingsIndividual"
    }
  },

  data() {
    return {
      searching: false
    };
  },

  computed: {
    emptyMessageText() {
      return this.searching
        ? "No members found with that name."
        : "No members found.";
    }
  },

  methods: {
    ...mapActions("superAdmin", ["generateLoginAsUrl"]),

    onSearch($event) {
      this.$emit("search", $event);
      $event === "" ? (this.searching = false) : (this.searching = true);
    },

    navigateToEditMember(memberId) {
      const route = {
        name: this.editMemberRouteName,
        params: {
          id: memberId
        }
      };
      if (this.superAdminMemberList) {
        route.query = { membersListOrigin: "super" };
      }
      this.$router.push(route);
    },

    async handleLoginAsFromList(memberId) {
      try {
        const loginUrl = await this.generateLoginAsUrl(memberId);
        window.open(loginUrl, "_blank", "noopener,noreferrer");
      } catch (error) {
        this.$store.dispatch("snackBar", {
          duration: 5000,
          type: "is-danger",
          message: "Failed to generate login URL. Please try again."
        });
      }
    },

    programName(member) {
      return this._.get(member, "programName") || "";
    },

    isAdminText(member) {
      return this._.has(member, "programAdmin.id") ? "Yes" : "No";
    },

    isAdminClass(member) {
      return this._.has(member, "programAdmin.id")
        ? "has-text-success has-text-weight-semibold"
        : "";
    }
  }
};
</script>

<style lang="sass" scoped>
.login-icon
  color: #3273dc  !important
  text-decoration: none  !important
  cursor: pointer  !important
</style>
